import React, { ReactElement } from "react";
import {
  Modal,
  ModalSize,
  Button,
} from "@screencloud/screencloud-ui-components";
import "./DeleteChannelWarningModal.scss";

interface DeleteChannelWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
}

const DELETE_CHANNEL_LABELS = {
  TITLE: "Be careful...",
  USAGE_NOTICE:
    "Other Broadcast app instances may be showing this Streaming Channel.",
  CONFIRMATION_MSG: "Are you sure you want to delete it?",
  RESULT_MSG: "(This action can not be undone)",
  CANCEL: "Cancel",
  DELETE: "Yes, Delete it",
};

const DeleteChannelWarningModal = (
  props: DeleteChannelWarningModalProps
): ReactElement<DeleteChannelWarningModalProps> => {
  const { isOpen, onClose } = props;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      size={ModalSize.SMALL}
      className="delete-channel-warning-modal"
    >
      <div className="delete-channel-warning">
        <div className="delete-channel-warning_msg">
          <p>
            <span className="header">{DELETE_CHANNEL_LABELS.TITLE}</span>
          </p>
          <p>{DELETE_CHANNEL_LABELS.USAGE_NOTICE}</p>
          <p>{DELETE_CHANNEL_LABELS.CONFIRMATION_MSG}</p>
          <p>{DELETE_CHANNEL_LABELS.RESULT_MSG}</p>
        </div>
        <div>
          <Button primary onClick={props.onCancel}>
            {DELETE_CHANNEL_LABELS.CANCEL}
          </Button>
          <Button outline="true" onClick={props.onConfirm}>
            {DELETE_CHANNEL_LABELS.DELETE}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteChannelWarningModal;
